import vueInstance from "../main";

export const itemsStatus = Object.freeze({
  STATUS_CREATED: 1,
  STATUS_READY_TO_SEND: 2,
  STATUS_ALREADY_SEND: 3,
  STATUS_CANCELED_BY_CLIENT: 0,
  STATUS_OFFER_SELECTED_BY_CLIENT: 4,
  STATUS_OFFER_ACCEPTED_BY_CLIENT: 5,
  STATUS_BOOKED: 6,
  STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER: 7,
  STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK: 8,
  STATUS_BOOKING_CANCELLED: 9,
  STATUS_CLIENT_REQUEST_BOOKING_CANCEL: 10
});

export const serviceStatus = Object.freeze({
  STATUS_CREATED: 1,
  STATUS_PARTLY_COMPLETED: 2,
  STATUS_SEND: 3,
  STATUS_CHOSEN_BY_CLIENT: 4,
  STATUS_ACCEPTED_BY_CLIENT: 5,
  STATUS_COMPLETE: 6,
  STATUS_REJECTED: 7,
  STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER: 8,
  STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK: 9,
  STATUS_CANCELLATION_REQUEST: 10
});

export const itemsFilterStatus = function() {
  return [
    {
      text: this.$t("travelService.orderStatus.statusCreated"),
      value: serviceStatus.STATUS_CREATED,
      color: "orange",
      icon: "fa-globe"
    },
    {
      text: this.$t("travelService.orderStatus.statusPartlyCompleted"),
      value: serviceStatus.STATUS_PARTLY_COMPLETED,
      color: "info",
      icon: "fa-globe"
    },
    {
      text: this.$t("travelService.orderStatus.statusSend"),
      value: serviceStatus.STATUS_SEND,
      color: "teal",
      icon: "fa-user-clock"
    },
    {
      text: this.$t("travelService.orderStatus.statusChosenByClient"),
      value: serviceStatus.STATUS_CHOSEN_BY_CLIENT,
      color: "primary",
      icon: "fa-user-clock"
    },
    {
      text: this.$t("travelService.orderStatus.statusAcceptedByClient"),
      value: serviceStatus.STATUS_ACCEPTED_BY_CLIENT,
      color: "success",
      icon: "fa-globe"
    },
    {
      text: this.$t("travelService.orderStatus.statusComplete"),
      value: serviceStatus.STATUS_COMPLETE,
      color: "grey",
      icon: "fa-check-circle"
    },
    {
      text: this.$t("travelService.orderStatus.statusRejected"),
      value: serviceStatus.STATUS_REJECTED,
      color: "danger",
      icon: "fa-minus-circle"
    },
    {
      text: this.$t("travelService.orderStatus.requestClientAnswerForOffer"),
      value: serviceStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER,
      color: "purple",
      icon: "fa-comment"
    },
    {
      text: this.$t("travelService.orderStatus.requestClientAnswerForBook"),
      value: serviceStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK,
      color: "purple",
      icon: "fa-comment"
    },
    {
      text: this.$t("travelService.orderStatus.requestCancellation"),
      value: serviceStatus.STATUS_CANCELLATION_REQUEST,
      color: "red",
      icon: "fa-ban"
    }
  ];
};

export const itemsFilterType = function() {
  let sorted = [
    { text: vueInstance.$t("travelService.types.hotel"), value: "hotel" },
    { text: vueInstance.$t("travelService.types.flight"), value: "flight" },
    { text: vueInstance.$t("travelService.types.rail"), value: "rail" },
    { text: vueInstance.$t("travelService.types.car"), value: "car" },
    { text: vueInstance.$t("travelService.types.insurance"), value: "insurance" }
  ].sort((a, b) => (a.text > b.text ? 1 : -1));
  sorted.push({ text: vueInstance.$t("travelService.types.other"), value: "other" });
  return sorted;
};

export const singleServiceOrderStatus = function() {
  return [
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusCanceledByClient"),
      value: itemsStatus.STATUS_CANCELED_BY_CLIENT,
      color: "grey",
      textColor: "white",
      icon: "fa-ban"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusCreated"),
      value: itemsStatus.STATUS_CREATED,
      color: "warning",
      textColor: "black",
      icon: "youtube_searched_for"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusReadyToSend"),
      value: itemsStatus.STATUS_READY_TO_SEND,
      color: "info",
      textColor: "white",
      icon: "hourglass_empty"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusAlreadySend"),
      value: itemsStatus.STATUS_ALREADY_SEND,
      color: "primary",
      textColor: "white",
      icon: "email"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusOfferSelectedByClient"),
      value: itemsStatus.STATUS_OFFER_SELECTED_BY_CLIENT,
      color: "primary",
      textColor: "white",
      icon: "fa-clipboard-list"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusAcceptedByClient"),
      value: itemsStatus.STATUS_OFFER_ACCEPTED_BY_CLIENT,
      color: "warning",
      textColor: "black",
      icon: "fa-user-check"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.statusBooked"),
      value: itemsStatus.STATUS_BOOKED,
      color: "success",
      textColor: "white",
      icon: "fa-check"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.requestClientAnswerForOffer"),
      value: itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_OFFER,
      color: "purple",
      textColor: "white",
      icon: "fa-edit"
    },
    {
      text: vueInstance.$t("travelService.singleServiceOrderStatus.requestClientAnswerForBook"),
      value: itemsStatus.STATUS_REQUEST_CLIENT_ANSWER_FOR_BOOK,
      color: "purple",
      textColor: "white",
      icon: "fa-edit"
    },
    {
      text: this.$t("travelService.singleServiceOrderStatus.requestBookingCancel"),
      value: itemsStatus.STATUS_CLIENT_REQUEST_BOOKING_CANCEL,
      color: "red",
      textColor: "white",
      icon: "fa-ban"
    },
    {
      text: this.$t("travelService.singleServiceOrderStatus.bookingCanceled"),
      value: itemsStatus.STATUS_BOOKING_CANCELLED,
      color: "grey",
      textColor: "white",
      icon: "fa-ban"
    }
  ];
};

export function bookingIconType(bookingType) {
  if (bookingType === "flight") return "fa-plane";
  if (bookingType === "car") return "fa-car";
  if (bookingType === "hotel") return "fa-hotel";
  if (bookingType === "rail") return "fa-subway";
  if (bookingType === "other") return "fa-suitcase";
  if (bookingType === "insurance") return "fa-clinic-medical";
}
